export class Command {
  dtoName: string;
  constructor(dtoName: string) {
    this.dtoName = dtoName;
  }
}
